import React, { useEffect } from "react";
import { Box, IconButton, ListItem } from "@material-ui/core";
import { MappingSectionForm, OuterList, useCreativeMappingsFormStyles } from "pages/CreativeMappings/components";
import { useForm, FormProvider } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {
    CreativeMappingsRuleForm,
    createDefaultCreativeMappingFormValues,
    creativeMappingsSchema,
    CreativesViewModel,
} from "validation/components/CreativeMappings/creativeMappingsRules";
import ClearIcon from "@material-ui/icons/Clear";
import CheckIcon from "@material-ui/icons/Check";
import { FilterSection } from "components/FilterSection/FilterSection";
import { useDispatch, useSelector } from "react-redux";
import {
    createCreativeMapping,
    getCreativeMappingsProcessingState,
    updateCreativeMapping,
} from "store/features/creativeMappings/overivew";
import { FilterViewModel } from "api/factories/ulits.factory";

interface CreativeMappingsFormProps {
    id?: number;
    isCopy?: boolean;
    resetOnSubmit?: boolean;
    filters?: FilterViewModel[];
    creatives?: CreativesViewModel[];
    onCancelEdit(id?: number): () => void;
}

export const CreativeMappingsForm = ({
    id,
    resetOnSubmit = false,
    isCopy = false,
    filters = [],
    creatives = [],
    onCancelEdit,
}: CreativeMappingsFormProps) => {
    // TODO: wrap with styled components when possible
    const classes = useCreativeMappingsFormStyles();
    const dispatch = useDispatch();
    const { isDeleting } = useSelector(getCreativeMappingsProcessingState);
    const methods = useForm<CreativeMappingsRuleForm>({
        resolver: yupResolver(creativeMappingsSchema),
        defaultValues: {
            filters,
            creatives,
        },
    });

    const handleFormSubmit = (form: CreativeMappingsRuleForm) => {
        if (resetOnSubmit) {
            methods.reset(createDefaultCreativeMappingFormValues);
        }

        if (isCopy || !id) {
            dispatch(createCreativeMapping.request(form));

            return;
        }

        dispatch(updateCreativeMapping.request({ ...form, id }));
    };

    useEffect(() => {
        if (!id) {
            return methods.reset(createDefaultCreativeMappingFormValues);
        }
        // eslint-disable-next-line
    }, []);

    return (
        <FormProvider {...methods}>
            <form className={classes.row}>
                <OuterList flex={4} disablePadding={true}>
                    <ListItem>
                        <FilterSection
                            source="creative-mappings/autocomplete"
                            disableHeader={true}
                            disableBackground={true}
                            disableMargins={true}
                        />
                    </ListItem>
                </OuterList>
                <OuterList flex={2} disablePadding={true}>
                    <ListItem>
                        <MappingSectionForm />
                    </ListItem>
                </OuterList>
                <Box p={2} display="flex" alignItems="flex-end">
                    <IconButton onClick={methods.handleSubmit(handleFormSubmit)}>
                        <CheckIcon color="primary" fontSize="small" />
                    </IconButton>
                    <IconButton onClick={onCancelEdit(id)} disabled={isDeleting}>
                        <ClearIcon color="error" fontSize="small" />
                    </IconButton>
                </Box>
            </form>
        </FormProvider>
    );
};
